import { createFileRoute } from '@tanstack/react-router';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';
import { PROTECTED, WORK_REPORTS } from '@/lib/constants/routes';

const RETURN_URL = `${PROTECTED}${WORK_REPORTS}`;

/**
 * Il pannello lo disegna `WorkReportPanelHost` nel layout (vedi `/new`): la
 * rotta dà URL, caricamento ed errore.
 */
export const Route = createFileRoute(
  '/protected/_layout/work-reports/_layout/$id'
)({
  ...createSheetRouteOptions(RETURN_URL, { size: 'wide' }),
  component: () => null,
});
